// extracted by mini-css-extract-plugin
export default {"expressCheckoutSection":"mC-z","expressButtonContainerWithPayPal":"nC-z","expressButton":"oC-z","or":"pC-z"};